/* eslint-disable no-unused-vars */
import { useState, useRef } from 'react';
import { fd, td } from '../theme';
import Ic from '../Icon';

const DOC_TYPES  = ['All','Lease','Notice','Addendum','Inspection','Receipt','Other'];

function safeUrl(url) {
  if (!url || url === '#') return null;
  try {
    const { protocol } = new URL(url);
    return (protocol === 'https:' || protocol === 'http:') ? url : null;
  } catch { return null; }
}
const TYPE_COLORS = { Lease:'bbl', Notice:'br', Addendum:'by', Inspection:'bg', Receipt:'bgo', Other:'b' };

export default function Documents({ docs = [], addDocument, deleteDocument, isLL, activeTenant }) {
  const [filterType, setFilterType] = useState('All');
  const [search,     setSearch]     = useState('');
  const [showAdd,    setShowAdd]    = useState(false);
  const [saving,     setSaving]     = useState(false);
  const [form, setForm] = useState({ name: '', type: 'Lease', tenant_id: '', uploaded_at: td(), file_url: '' });
  const fileRef = useRef(null);

  const visible = docs
    .filter(d => !activeTenant || (d.tenant_id || d.tid) === activeTenant.id)
    .filter(d => filterType === 'All' || d.type === filterType)
    .filter(d => !search || (d.name || '').toLowerCase().includes(search.toLowerCase()));

  const addDoc = async () => {
    if (!form.name) return;
    setSaving(true);
    if (addDocument) {
      await addDocument({
        name:        form.name,
        type:        form.type,
        tenant_id:   form.tenant_id || null,
        uploaded_at: form.uploaded_at,
        file_url:    form.file_url || null,
      });
    }
    setForm({ name: '', type: 'Lease', tenant_id: '', uploaded_at: td(), file_url: '' });
    setShowAdd(false);
    setSaving(false);
  };

  const removeDoc = async id => {
    if (deleteDocument) await deleteDocument(id);
  };

  return (
    <div>
      <div className="card">
        <div className="card-hd">
          <h3>Document Vault</h3>
          {isLL && (
            <button className="btn btn-g" style={{ padding:'6px 14px', fontSize:12 }} onClick={() => setShowAdd(true)}>
              <Ic n="plus" s={13}/> Add Document
            </button>
          )}
        </div>

        <input className="srch" value={search} onChange={e => setSearch(e.target.value)} placeholder="Search documents..."/>

        <div className="tabs">
          {DOC_TYPES.map(t => (
            <button key={t} className={`tab${filterType===t?' tab-on':''}`} onClick={() => setFilterType(t)}>{t}</button>
          ))}
        </div>

        {visible.length === 0 ? (
          <div style={{ textAlign:'center', padding:'40px 20px', color:'#484f58' }}>
            <Ic n="doc" s={36} c="#484f58"/>
            <div style={{ marginTop:12, fontSize:13 }}>No documents found</div>
            {isLL && <div style={{ fontSize:12, marginTop:4 }}>Upload lease agreements, inspection reports, and notices here.</div>}
          </div>
        ) : (
          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            {visible.map(d => (
              <div key={d.id} style={{ display:'flex', alignItems:'center', gap:12, padding:'12px 14px', background:'#21262d', borderRadius:10 }}>
                <div style={{ width:38, height:38, borderRadius:8, background:'rgba(88,166,255,.1)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  <Ic n="doc" s={18} c="#58a6ff"/>
                </div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:13, fontWeight:600, color:'#fff', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{d.name}</div>
                  <div style={{ display:'flex', alignItems:'center', gap:8, marginTop:3 }}>
                    <span className={`b ${TYPE_COLORS[d.type]||'b'}`} style={{ fontSize:10, padding:'1px 7px' }}>{d.type}</span>
                    <span style={{ fontSize:11, color:'#484f58' }}>{fd(d.uploaded_at)}</span>
                    {d.size && d.size !== '—' && <span style={{ fontSize:11, color:'#484f58' }}>{d.size}</span>}
                  </div>
                </div>
                <div style={{ display:'flex', gap:6 }}>
                  {safeUrl(d.file_url) ? (
                    <a href={safeUrl(d.file_url)} target="_blank" rel="noreferrer" className="btn btn-d" style={{ padding:'5px 10px', fontSize:11, textDecoration:'none' }}>
                      <Ic n="dl" s={12}/> View
                    </a>
                  ) : (
                    <span className="btn btn-gh" style={{ padding:'5px 10px', fontSize:11, opacity:0.4, cursor:'default' }}>
                      <Ic n="dl" s={12}/> No file
                    </span>
                  )}
                  {isLL && deleteDocument && (
                    <button className="btn btn-gh" style={{ padding:'5px 9px' }} onClick={() => removeDoc(d.id)}>
                      <Ic n="x" s={12}/>
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {showAdd && (
        <div className="mov" onClick={e => e.target === e.currentTarget && setShowAdd(false)}>
          <div className="modal">
            <div className="mhd">
              <h2>Add Document</h2>
              <button className="btn btn-gh" style={{ padding:'5px 9px' }} onClick={() => setShowAdd(false)}><Ic n="x" s={15}/></button>
            </div>
            <div className="mbdy">
              <div className="fg">
                <div className="fi fi-f">
                  <label>Document Name</label>
                  <input value={form.name} onChange={e => setForm(p => ({...p, name: e.target.value}))} placeholder="e.g. Lease Agreement – John Smith" autoFocus/>
                </div>
                <div className="fi">
                  <label>Type</label>
                  <select value={form.type} onChange={e => setForm(p => ({...p, type: e.target.value}))}>
                    {DOC_TYPES.filter(t => t !== 'All').map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>
                <div className="fi">
                  <label>Date</label>
                  <input type="date" value={form.uploaded_at} onChange={e => setForm(p => ({...p, uploaded_at: e.target.value}))}/>
                </div>
                <div className="fi">
                  <label>Document URL (optional)</label>
                  <input value={form.file_url} onChange={e => setForm(p => ({...p, file_url: e.target.value}))} placeholder="https://..."/>
                </div>
              </div>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:12 }}>
                <button className="btn btn-gh" onClick={() => setShowAdd(false)}>Cancel</button>
                <button className="btn btn-g" onClick={addDoc} disabled={!form.name || saving}>
                  <Ic n="plus" s={14}/>{saving ? 'Saving...' : 'Add Document'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
